import script from "./ProductOverview.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductOverview.vue?vue&type=script&setup=true&lang=ts"

import "./ProductOverview.vue?vue&type=style&index=0&id=989ea258&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-989ea258"]])

export default __exports__